export enum PredefinedPermissions {

    ProductEdit = 'put./api/v1/product/:id',
    ProductDelete = 'delete./api/v1/product/:id',
    ProductDeleteBulk = 'delete./api/v1/product',
    ProductRecover = 'patch./api/v1/product/:id?status',
    ProductRecoverBulk = 'patch./api/v1/product?code&status',
    ProductRecommendToggle = 'patch./api/v1/product/:id?recommend',
    ProductRecommendToggleBulk = 'patch./api/v1/product?code&recommend',
    ProductNew = 'post./api/v1/product',
    ProductNewBulk = 'post./api/v1/products',
    ProductCatalogNew = 'post./api/v1/productcatalog',
    ProductCatalogEdit = 'put./api/v1/productcatalog/:id',
    ProductCatalogDelete = 'delete./api/v1/productcatalog/:id',
    ProductCatalogMerge = 'put./api/v1/productcatalog/:id/tocatalog/:toid',
    ProductCountryNew = 'post./api/v1/country',
    ProductCountryEdit = 'put./api/v1/country/:id',
    ProductCountryDelete = 'delete./api/v1/country/:id',
    ProductCountryDeleteBulk = 'delete./api/v1/countries',
    ProductRegionNew = 'post./api/v1/region',
    ProductRegionEdit = 'put./api/v1/region/:id',
    ProductRegionDelete = 'delete./api/v1/region/:id',

    PromotionDiscountDate = 'post./api/v1/promotion/discountdate',
    PromotionDiscountCatalog = 'post./api/v1/promotion/discountcatalog',
    PromotionDiscountCreationDate = 'post./api/v1/promotion/discountcreationdate',
    PromotionDiscountIndividual = 'post./api/v1/promotion/discountindividual',
    PromotionDiscountCount = 'post./api/v1/promotion/discountcount',
    PromotionDiscountAmount = 'post./api/v1/promotion/discountamount',

    OrderList = 'get./api/v1/orders',
    OrderDetail = 'get./api/v1/order/:id',
    OrderInvoiceRequest = 'get./api/v1/invoicerequests',
    OrderInvoiceRequestEdit = 'put./api/v1/invoicerequest/:id',
    OrderInvoiceRequestDelete = 'delete./api/v1/invoicerequest/:id',

    MarketingEmail = 'post./api/v1/marketing',

    SampleDelete = 'delete./api/v1/sample/:id',
    SampleDeleteBulk = 'delete./api/v1/sample',
    SampleNew = 'post./api/v1/sample/:id',
    SampleNewBulk = 'post./api/v1/samples/:id',
    SampleInvoiceRequest = 'get./api/v1/samplerequests',

    ArticleNew = 'post./api/v1/article',
    ArticleEdit = 'put./api/v1/article/:id',
    ArticleDelete = 'delete./api/v1/article/:id',
    ArticleDeleteBulk = 'delete./api/v1/article',
    ArticleRecover = 'patch./api/v1/article/:id?status',
    ArticleRecoverBulk = 'patch./api/v1/article?code&status',
    ArticleCatalogNew = 'post./api/v1/articlecatalog',
    ArticleCatalogEdit = 'put./api/v1/articlecatalog/:id',
    ArticleCatalogDelete = 'delete./api/v1/articlecatalog/:id',
    ArticleCatalogMerge = 'put./api/v1/articlecatalog/:id/tocatalog/:tid',
    ArticleRecommendToggle = 'patch./api/v1/article/:id?recommend',
    ArticleRecommendToggleBulk = 'patch./api/v1/article?code&recommend',

    ManufacturerNew = 'post./api/v1/manufacturer',
    ManufacturerEdit = 'put./api/v1/manufacturer/:id',
    ManufacturerDelete = 'delete./api/v1/manufacturer/:id',
    ManufacturerDeleteBulk = 'delete./api/v1/manufacturer',
    ManufacturerRecover = 'patch./api/v1/manufacturer/:id?status',
    ManufacturerRecoverBulk = 'patch./api/v1/manufacturer?id&status',
    ManufacturerPriceNew = 'post./api/v1/manufacturerprice',
    ManufacturerPriceEdit = 'put./api/v1/manufacturerprice/:id',
    ManufacturerPriceDelete = 'delete./api/v1/manufacturerprice/:id',
    ManufacturerPriceDeleteBulk = 'delete./api/v1/manufacturerprice',

    CustomerList = 'get./api/v1/customers',
    CustomerNew = 'post./api/v1/customer',
    CustomerDetail = 'get./api/v1/customer/:id',
    CustomerEdit = 'put./api/v1/customer/:id',
    CustomerDelete = 'delete./api/v1/customer/:id',
    CustomerDeleteBulk = 'delete./api/v1/customer',
    CustomerRecover = 'patch./api/v1/customer/:id?status',
    CustomerRecoverBulk = 'patch./api/v1/customer?username&status',
    CustomerReset = 'patch./api/v1/customer/:id?reset',
    CustomerMessageList = 'get./api/v1/customermessages',
    CustomerMessageNew = 'post./api/v1/customermessage/:id',
    CustomerMessageDelete = 'delete./api/v1/customermessage/:id',
    CustomerMessageDeleteBulk = 'delete./api/v1/customermessage?id',
    CustomerMessageRecover = 'patch./api/v1/customermessage/:id?status',
    CustomerMessageRecoverBulk = 'patch./api/v1/customermessage?id&status',
    CustomerMessageEdit = 'put./api/v1/customermessage/:id',

    PermissionList = 'get./api/v1/permissions',
    PermissionUserList = 'get./api/v1/permissionusers',
    PermissionUserDetail = 'get./api/v1/permissionuser/:id',
    PermissionUserNew = 'post./api/v1/permissionuser',
    PermissionUserEdit = 'put./api/v1/permissionuser/:id',
    PermissionUserDelete = 'delete./api/v1/permissionuser/:id',
    PermissionUserDeleteBulk = 'delete./api/v1/permissionuser',
    PermissionUserRecover = 'patch./api/v1/permissionuser/:id?status',
    PermissionUserRecoverBulk = 'patch./api/v1/permissionuser?username&status',
    PermissionUserResetPassword = 'patch./api/v1/permissionuser/:id?resetpwd',
    PermissionUserAddToRole = 'post./api/v1/permissionuser/:id/role/:rid',
    PermissionUserRemoveFromRole = 'delete./api/v1/permissionuser/:id/role/:rid',
    PermissionRoleList = 'get./api/v1/permissionroles',
    PermissionRoleDetail = 'get./api/v1/permissionrole/:id',
    PermissionRoleNew = 'post./api/v1/permissionrole',
    PermissionRoleEdit = 'put./api/v1/permissionrole/:id',
    PermissionRoleAddPermission = 'post./api/v1/permissionrole/:id/permission/:pid',
    PermissionRoleAddPermissionBulk = 'post./api/v1/permissionrole/:id/permissions',
    PermissionRoleRemovePermission = 'delete./api/v1/permissionrole/:id/permission/:pid',
    PermissionRoleRemovePermissionBulk = 'delete./api/v1/permissionrole/:id/permissions',
    PermissionRoleDelete = 'delete./api/v1/permissionrole/:id',
    PermissionRoleDeleteBulk = 'delete./api/v1/permissionrole',
    PermissionRoleRecover = 'patch./api/v1/permissionrole/:id?status',
    PermissionRoleRecoverBulk = 'patch./api/v1/permissionrole?roleName&status',

    SystemProperties = 'put./api/v1/properties',
    SystemSiteLogo = 'post./api/v1/property/sitelogo',
    SystemLogs = 'get./api/v1/logs',

    StatisticsNewProduct = 'get./api/v1/statistics/productupload',
    StatisticsNewSample = 'get./api/v1/statistics/sampleupload',
    StatisticsNewCustomer = 'get./api/v1/statistics/newcustomer',
    StatisticsNewOrder = 'get./api/v1/statistics/neworder',
    StatisticsNewOrderAmount = 'get./api/v1/statistics/orderamount'

}
